import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

const APP_TITLE = 'SmartHead Admin';

export function formatPageTitle(title: string | undefined): string {
  return title ? `${title} · ${APP_TITLE}` : APP_TITLE;
}

/**
 * Browser tab title from the route `title`, a page with a dynamic title (a profile) sets it by `formatPageTitle`.
 */
@Injectable({ providedIn: 'root' })
export class AdminTitleStrategy extends TitleStrategy {
  readonly #title = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.#title.setTitle(formatPageTitle(this.buildTitle(snapshot)));
  }
}
